<template>
  <div class="overflow-auto">
    <b-pagination
      v-model="value.currentPage"
      :total-rows="value.total"
      :per-page="value.perPage"
      :size="size"
      class="mb-0"
    />
    <small v-if="value.total > 0">
      Exibindo {{ page_ini }} a {{ page_fim }} de um total de
      {{ value.total }} registros
    </small>
  </div>
</template>

<script>
export default {
  props: {
    last_page: {
      default: 1,
    },
    size: {
      type: String,
      default: "sm",
    },
    value: {
      type: Object,
      default: () => ({
        currentPage: 1,
        perPage: 10,
        total: 0,
      }),
    },
  },
  data: () => ({}),
  computed: {
    page_ini() {
      let ini = (this.value.currentPage - 1) * this.value.perPage;
      return ini + 1;
    },
    page_fim() {
      let fim = this.value.currentPage * this.value.perPage;
      fim = fim > this.value.total ? this.value.total : fim;
      return fim;
    },
  },
};
</script>

<style>
</style>
